<template>
    <div class="vm-nav-header-pc">
        <div class="inner-box flex-box flex-align-items-center flex-justify-content-space-between nowrap">
            <div class="flex-box flex-align-items-center">
                <router-link
                    :to="{ name: 'index' }"
                    class="flex-box flex-align-items-center fs-24-16 mq"
                >
                    <img class="logo-img mr16 mq" src="/static/img/logo/logo.png" alt="">
                    <span class="purple">{{$t('c.NavHeaderPC.text1')}}</span>
                </router-link>
                <template v-if="fr != 'wx'">
                    <router-link
                        :to="{ name: 'feed' }"
                        class="fs16 ml-80-16 mq explore-door relative"
                        active-class="on"
                    >{{$t('c.NavHeaderPC.text2')}}
                        <div class="line-active"></div>
                        <i v-if="unread_post_num > 0" class="red-point"></i>
                    </router-link>
                    <router-link
                        :to="{ name: 'explore' }"
                        class="fs16 ml-40-16 mq explore-door"
                        active-class="on"
                    >{{$t('c.NavHeaderPC.text3')}}
                        <div class="line-active"></div>
                    </router-link>
                    <router-link to="/app" class="fs16 ml-40-16 mq explore-door" active-class="on">
                        <i class="afd afd-app black-3"></i>
                        {{$t('c.NavHeaderPC.text4')}}
                    </router-link>
                    <!-- <router-link
                        v-if="!session_user"
                        :to="{ name: 'music' }"
                        class="fs16 ml-40-16 mq explore-door"
                        active-class="on"
                    >音乐
                        <div class="line-active"></div>
                    </router-link>
                    <router-link
                        v-if="!session_user"
                        :to="{ name: 'cartoon' }"
                        class="fs16 ml-40-16 mq explore-door"
                        active-class="on"
                    >动漫
                        <div class="line-active"></div>
                    </router-link> -->
                    <div class="ml-40-16 mq flex-box flex-align-items-center">
                        <i class="afd afd-search black-3"></i>
                        <input
                            class="gl-input pl16"
                            v-model="query"
                            style="border-color: transparent;"
                            @keyup.enter="search"
                            type="text"
                            :placeholder="`${$t('c.NavHeaderPC.text19')}...`"
                        >
                    </div>
                </template>
            </div>
            <div class="relative flex-box flex-align-items-center" v-if="auth_token != -1">
                <!--<router-link :to="{name: 'create'}" class="mr24 fs16">-->
                <!--成为创作者-->
                <!--</router-link>-->
                <!--<router-link v-if="browser_size == 'small' && auth_token == ''" :to="{name: 'explore'}" class="mr24 mq">发现</router-link>-->

                <template v-if="!session_user">
                    <!-- <div @click="open_lang" class="flex-box black-8 flex-a-center mr32 pointer">{{$t('c.NavHeaderPC.text21')}}<i class="ml8 afd afd-arrow-down"></i></div> -->
                    <div
                        v-if="$route.name != 'login'"
                        :to="{ name: 'login' }"
                        class="login-door pointer"
                        :class="{mr24: $route.name != 'login' && $route.name != 'reg',}"
                        @click="jump('login')"
                    >{{$t('c.NavHeaderPC.text5')}}</div>
                    <div
                        v-if="$route.name != 'reg'"
                        :to="{ name: 'reg' }"
                        class="fs16 reg-door fwb purple"
                        @click="jump('reg')">
                        <btn class="look3">{{$t('c.NavHeaderPC.text6')}}</btn>
                    </div>
                </template>
                <template v-else>
                    <router-link
                        class="mr24"
                        :to="{ name: 'apply' }"
                        v-if="!is_creator && fr != 'wx'"
                    >
                        <btn class="look3">{{$t('c.NavHeaderPC.text7')}}</btn>
                    </router-link>
                    <div
                        v-if="is_creator && browser_size == 'small'"
                        class="flex-box flex-align-items-center gl-hover-text-purple mr24 purple"
                        @click="show_modal_feed"
                    >
                        <i class="afd afd-plus"></i>
                    </div>
                    <btn
                        v-if="is_creator && browser_size != 'small'"
                        class="look3 mr24"
                        @click.native="show_modal_feed"
                    ><i class='afd afd-plus'></i><span class='ml8'>{{$t('c.NavHeaderPC.text20')}}</span></btn>
                    <template v-if="fr != 'wx'">
                        <router-link v-if="is_creator" :to="{ name: 'dashboardStats'}" class="black-5 gl-hover-text relative mr24">
                          {{$t('c.NavHeaderPC.text8')}}
                        </router-link>
                        <router-link v-if="is_creator" :to="{ name: 'settingAccount' }" class="black-5 gl-hover-text relative mr24">
                          {{$t('c.NavHeaderPC.text9')}}
                        </router-link>
                        <router-link :to="{ name: 'message' }" class="message-remind-box black-5 gl-hover-text relative mr24">
                            <i class="afd afd-mail"></i>
                            <tag class="cyan circle" v-if="unread_message_num">
                                {{unread_message_num > 99 ? "99+": unread_message_num}}
                            </tag>
                        </router-link>
                    </template>
                    <div @mouseenter="show_menu" @mouseleave="close_menu">
                        <div class="pointer avatar-box" @click="show_menu">
                            <pic class="circle" :src="session_user.avatar" width="40" height="40"></pic>
                        </div>
                        <div
                            class="menu"
                            v-if="session_user && is_show_menu"
                            v-click-outside="close_menu"
                        >
                            <div class="menu-inner-box">
                                <div class="type-1">
                                    <router-link
                                        :to="$userlink(session_user)"
                                        class="link-1"
                                    >{{$t('c.NavHeaderPC.text10')}}</router-link>
                                    <!-- <router-link v-else :to="{ name: 'apply' }" class="link-1">成为创作者</router-link> -->
                                </div>
                                <div class="type-2">
                                    <!-- <router-link
                                        v-if="!is_creator"
                                        :to="$userlink(session_user)"
                                        class="link-2"
                                    >我的主页</router-link> -->
                                    <router-link
                                        v-if="is_creator"
                                        :to="{ name: 'dashboardStats' }"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text11')}}</router-link>
                                    <router-link
                                        v-else
                                        :to="{ name: 'dashboardSponsoring' }"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text11')}}</router-link>
                                    <router-link
                                        :to="{ name: 'settingAccount' }"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text12')}}</router-link>

                                    <router-link
                                        :to="{ name: 'dashboardOrder' }"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text13')}}</router-link>
                                    <router-link
                                        :to="{ name: 'dashboardMark' }"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text14')}}</router-link>
                                    <div class="line mt10 mb10"></div>
                                    <!-- <router-link
                                        to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377"
                                        class="link-2 gl-hover-text"
                                    >常见问题</router-link> -->
                                    <router-link
                                        to="/message/27f7cea2370d11e8ae8852540025c377"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text15')}}</router-link>
                                    <router-link
                                        v-if="is_creator"
                                        to="/dashboard/dev"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text16')}}</router-link>
                                    <router-link
                                        to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377"
                                        class="link-2 gl-hover-text"
                                    >{{$t('c.NavHeaderPC.text17')}}</router-link>
                                    <span class="link-2 gl-hover-text" @click="open_lang">{{$t('c.NavHeaderPC.text21')}}</span>
                                    <!-- <div
                                        class="link-2 gl-hover-text"
                                        @click="tab_theme"
                                    >{{theme_text}}主题</div> -->
                                    <div class="link-2 gl-hover-text" @click="logout">{{$t('c.NavHeaderPC.text18')}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "nav-header-pc",
    props: {},
    inject:['app_action_sheet'],
    computed: {
        ...mapState("app", [
            "session_user",
            "user_status",
            "auth_token",
            "browser_size",
            "unread_message_num",
            "unread_post_num",
            "is_applying_apple",
            "is_applying_google",
            "afdian_theme",
            "locale_lang",
        ]),
        theme_text(){
            return this.afdian_theme == 'dark' ? '浅色': '深色'
        },
        group_id() {
            return this.$route.params.groupId;
        },
        is_creator() {
            if (
                this.session_user &&
                this.session_user.creator &&
                this.session_user.creator.status
            ) {
                return true;
            }
            return false;
        },
    },
    watch: {
        query(v) {
            this.$store.dispatch("app/set:q", v);
        },
    },
    data() {
        return {
            is_show_menu: false,
            query: this.$route.query.q || "",
            fr: this.$route.query.fr || "",
        };
    },
    mounted() {},
    methods: {
        search() {
            this.$router.push({ name: "search", query: { q: this.query } });
        },
        show_modal_feed() {
            this.$mixin_show_modal_feed();
        },
        show_menu(a) {
            if(this.fr == 'wx'){
                return fasle;
            }
            this.is_show_menu = true;
        },
        close_menu() {
            this.is_show_menu = false;
        },
        logout() {
            this.$bus.$emit("SESSION_EXPIRED", {is_request_logout: true});
            this.$store.commit('app/set:redirect_url', this.$route.fullPath);
            this.$router.push({ name: "login" });
        },
        jump(name){
            let n = this.$route.name
            if(n != 'login' && n != 'reg'){ //防止这两个页面来回跳
                this.$store.commit('app/set:redirect_url', this.$route.fullPath);
            }
            this.$router.push({name});
        },
        open_lang(e){
          this.app_action_sheet('open', {
            component:'action-lang',
            classname: 'lang'
          })
        }
    },
};
</script>
<style lang="stylus" scoped>
.vm-nav-header-pc {
    position: fixed;
    left: 0;
    top: 0;
    // transform translate(-50%,0)
    width: 100%;
    background: $white-bg;
    box-sizing: border-box;
    z-index: 99;
    height: px2rem(80);
    display: flex;

    .logo-img {
        width: px2rem(40);
        height: px2rem(40);
    }

    .inner-box {
        border-bottom: 1px solid $grey;
        // padding px2rem(24) 0
        box-sizing: border-box;
        max-width: $width-pc;
        margin: 0 auto;
        width: 100%;
    }

    .avatar-box {
        width: px2rem(32);
        height: px2rem(32);
    }

    .menu {
        padding: 0 px2rem(16);
        background: $white;
        position: absolute;
        width: px2rem(160);
        box-sizing: border-box;
        border-radius: px2rem(2);
        border: 1px solid $black-1;
        right: 0;
        top: px2rem(30);
        box-shadow: $layer-shadow;

        .type-1 {
            border-bottom: 1px solid $black-1;

            .link-1 {
                color: $purple;
                padding: px2rem(16) 0;
                display: block;
            }
        }

        .type-2 {
            padding: px2rem(8) 0;

            .link-2 {
                padding: px2rem(8) 0;
                display: block;
                color: $black-8;
                cursor: pointer;
            }
        }
    }

    .message-remind-box {
        .vm-tag {
            position: absolute;
            top: 0;
            right: 0;
            transform: translate(70%, -60%);
        }
    }

    .explore-door {
        &.on {
            position: relative;
            color: $purple;

            .line-active {
                height: 2px;
                background: $purple;
                width: 100%;
                position: absolute;
                bottom: _px2rem(29);
            }
        }
    }

    .red-point {
        position: absolute;
        width: px2rem(6);
        height: px2rem(6);
        border-radius: 100px;
        background: $red;
        left: 50%;
        top: _px2rem(3);
        margin-left: px2rem(14);
        border: 3px solid $white-bg;
    }

    @media (max-width: $width-mobile) {
        height: px2rem(64);
        padding: 0 px2rem(16);

        .inner-box {
            // padding px2rem(18) 0
        }

        .reg-door {
            .vm-btn {
                background: none;
                font-size: fs2rem(16);
            }
        }

        .avatar-box {
            width: px2rem(24);
            height: px2rem(24);
        }

        .explore-door {
            &.on {
                .line-active {
                    bottom: _px2rem(21);
                }
            }
        }

        .menu {
            padding: 0 px2rem(32);
            position: fixed;
            width: 100vw;
            border-radius: 0;
            top: px2rem(60);
            box-shadow: $layer-shadow;
            border-top: 0;

            .type-1 {
                .link-1 {
                    padding: px2rem(24) 0;
                }
            }

            .type-2 {
                padding: px2rem(12) 0;

                .link-2 {
                    padding: px2rem(12) 0;
                }
            }
        }
    }

    @media (min-width: $width-mobile + 1) and (max-width: $width-pc) {
        padding: 0 px2rem(24);
    }
}
</style>
